import {
  EnvironmentName,
  enterNode,
} from '../../utils/tree-operations/environments.ts'
import { makeProjectionStateField } from '../../utils/projection-state-field.ts'

export const documentEnvironmentNames =
  makeProjectionStateField<EnvironmentName>(enterNode)
